export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/get-component-display-name.js